import { render } from "./EventButton.vue?vue&type=template&id=64823912&bindings={}"
import script from "./EventButton.vue?vue&type=script&lang=ts"
export * from "./EventButton.vue?vue&type=script&lang=ts"
script.render = render

export default script